export const ASSESSMENT_REMARKS_FIELD_NAME = "remarks";
